export default "__VITE_ASSET__BR39bmWc__"